import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-briefcase-blank" }, null, -1)
const _hoisted_2 = { class: "el-form-item__label" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user-tie" }, null, -1)
const _hoisted_4 = { class: "el-form-item__label" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-notes" }, null, -1)
const _hoisted_6 = { class: "el-form-item__label" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-star" }, null, -1)
const _hoisted_8 = { class: "el-form-item__label" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user" }, null, -1)
const _hoisted_10 = { class: "el-form-item__label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-building" }, null, -1)
const _hoisted_12 = { class: "el-form-item__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_crm_user_select = _resolveComponent("crm-user-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_crm_contact_select = _resolveComponent("crm-contact-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_crm_account_select = _resolveComponent("crm-account-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref: "formComponent",
            rules: _ctx.rules,
            model: _ctx.form,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { prop: "title" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("LeadCreation.LeadTitle")), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "leadManagerId" }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("LeadCreation.ManagerLabel")), 1),
                  _createVNode(_component_crm_user_select, {
                    modelValue: _ctx.form.leadManagerId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.leadManagerId) = $event)),
                    class: "form-item-content",
                    "seller-only": true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "personalNote" }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("LeadCreation.PersonalNote")), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.personalNote,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.personalNote) = $event)),
                    type: "textarea",
                    rows: 2,
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "isFavorite" }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("LeadCreation.Favorite")), 1),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.form.isFavorite,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.isFavorite) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "contactId" }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("LeadCreation.ContactLabel")), 1),
                  _createVNode(_component_el_row, { class: "form-item-content row-container" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: _ctx.hasContactCreationPermission ? 22 : 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_crm_contact_select, {
                            modelValue: _ctx.form.contactId,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.contactId) = $event)),
                            onChange: _ctx.contactChanged
                          }, null, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }, 8, ["span"]),
                      (_ctx.hasContactCreationPermission)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            span: 2,
                            class: "add-button"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("i", {
                                class: "far fa-plus",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createNewContact()))
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.accountVisible)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    prop: "accountId"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("ContactCreation.AccountLabel")), 1),
                      _createVNode(_component_el_row, { class: "form-item-content row-container" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            span: _ctx.hasAccountCreationPermission ? 22 : 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_crm_account_select, {
                                modelValue: _ctx.form.accountId,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.accountId) = $event)),
                                onChange: _ctx.accountChanged
                              }, null, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }, 8, ["span"]),
                          (_ctx.hasAccountCreationPermission)
                            ? (_openBlock(), _createBlock(_component_el_col, {
                                key: 0,
                                span: 2,
                                class: "add-button"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", {
                                    class: "far fa-plus",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createNewAccount()))
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["rules", "model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}